import React from 'react'
import { Link } from 'react-router-dom'
import { COMPANY, SERVICES, NAV_LINKS } from '../data/siteData'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-stone-950 text-stone-300 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Col 1: About & Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div>
                <h3 className="text-stone-100 font-bold text-lg leading-tight">
                  {COMPANY.name}
                </h3>
                <p className="text-xs text-stone-400 uppercase tracking-wider">
                  Entreprenør & anlægsarbejde
                </p>
              </div>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">
              Lokal anlægsvirksomhed i Hjortshøj. Vi udfører nedgravning af trampoliner, belægning, fundament & sokkel samt maskingravning i Østjylland og på Djursland.
            </p>
            <div className="pt-2">
              <span className="inline-block text-xs font-semibold uppercase tracking-wider px-2.5 py-1 rounded bg-stone-900 border border-stone-800 text-emerald-400">
                Direkte kontakt til Jonas
              </span>
            </div>
          </div>

          {/* Col 2: Services */}
          <div>
            <h4 className="text-stone-100 font-bold text-sm uppercase tracking-wider mb-4 border-l-2 border-[#015205] pl-2.5">
              Ydelser
            </h4>
            <ul className="space-y-2.5 text-sm">
              {SERVICES.map((s) => (
                <li key={s.path}>
                  <Link
                    to={s.path}
                    className="text-stone-400 hover:text-emerald-400 transition-colors inline-flex items-center gap-2 group"
                  >
                    <i className="fa-solid fa-angle-right text-[10px] text-stone-600 group-hover:text-emerald-400 group-hover:translate-x-0.5 transition-all" aria-hidden="true"></i>
                    <span>{s.title}</span>
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/ydelser"
                  className="text-emerald-400 hover:text-emerald-300 font-medium inline-flex items-center gap-1.5 pt-1"
                >
                  <span>Alle ydelser</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Quick Navigation */}
          <div>
            <h4 className="text-stone-100 font-bold text-sm uppercase tracking-wider mb-4 border-l-2 border-[#015205] pl-2.5">
              Navigation
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-stone-400 hover:text-emerald-400 transition-colors inline-flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-stone-600 group-hover:text-emerald-400 transition-colors" aria-hidden="true"></i>
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link to="/om-jt-knudsen" className="text-stone-400 hover:text-emerald-400 transition-colors inline-flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-stone-600 group-hover:text-emerald-400 transition-colors" aria-hidden="true"></i>
                  <span>Om JT Knudsen</span>
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="text-stone-400 hover:text-emerald-400 transition-colors inline-flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-stone-600 group-hover:text-emerald-400 transition-colors" aria-hidden="true"></i>
                  <span>Galleri & projekter</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-stone-400 hover:text-emerald-400 transition-colors inline-flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-stone-600 group-hover:text-emerald-400 transition-colors" aria-hidden="true"></i>
                  <span>Kontakt & tilbud</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact details */}
          <div>
            <h4 className="text-stone-100 font-bold text-sm uppercase tracking-wider mb-4 border-l-2 border-[#015205] pl-2.5">
              Kontakt
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-user text-emerald-500 mt-1" aria-hidden="true"></i>
                <span className="text-stone-300 font-medium">Jonas Knudsen</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-phone text-emerald-500 mt-1" aria-hidden="true"></i>
                <a
                  href={COMPANY.phoneHref}
                  className="text-stone-300 hover:text-emerald-400 transition-colors font-semibold whitespace-nowrap"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-envelope text-emerald-500 mt-1" aria-hidden="true"></i>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="text-stone-300 hover:text-emerald-400 transition-colors whitespace-nowrap break-keep"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-emerald-500 mt-1" aria-hidden="true"></i>
                <span className="text-stone-400">
                  {COMPANY.address}
                </span>
              </li>
            </ul>

            <div className="mt-4 pt-3 border-t border-stone-800 text-xs text-stone-400">
              <p className="font-medium text-stone-300">Dækningsområde:</p>
              <p className="mt-1">
                Hjortshøj, Aarhus, Grenaa, Hornslet, Hinnerup, Egå samt resten af Østjylland & Djursland.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar - STRICT RULE: NO cookie or privacy policy links */}
        <div className="mt-12 pt-8 border-t border-stone-800/80 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-stone-400">
          <p>
            &copy; {currentYear} {COMPANY.name}. Alle rettigheder forbeholdes.
          </p>
          <div className="flex items-center gap-2 text-stone-400">
            <span>Professionelt anlægs- & gravearbejde udført ordentligt</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
